import React, { useEffect, useState } from 'react'
import { MyModal } from '~/components/ui/MyModal'
import styled from 'styled-components'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import {
  // 提交举报
  COMPLAIN_COMFIRM,
  // 举报类型
  COMPLAIN_TYPE_LIST,
  // 是否可以举报
  COMPLAIN_CAN_COMPLAINT,
} from '~/graphqls/gqls'
import {
  squarePostComplaint,
  squarePostComplaintVariables,
  canComplaint,
  canComplaintVariables,
} from '~/graphqls/types'
import { useMutation } from '@apollo/client'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { graphQLErrorMessage } from '~/utils'

import styles from './Complain.module.css'
import { Col, Input, message, Row } from 'antd'
import classNames from 'classnames'
import { MyBtn } from '~/components/ui/MyBtn'

const CustomMyModal = styled(MyModal)`
  .ant-modal-body {
    padding: 16px 36px;
  }
`

export const Complain = ({ postId }: { postId: number }) => {
  const { validateIsLogin } = useValidateAuth()
  // 控制弹窗显示/隐藏
  const [visible, setVisible] = useState(false)
  // 举报理由
  const [remark, setRemark] = useState('')
  // 举报类型
  const [complainTypeList, setComplainTypeList] = useState<string[]>([])
  const getComplainTypeList = useImperativeQuery(COMPLAIN_TYPE_LIST)
  const [selected, setSelected] = useState<number | null>(null)
  // 发送举报内容
  const [sendComplain, { loading: uploading }] = useMutation<
    squarePostComplaint,
    squarePostComplaintVariables
  >(COMPLAIN_COMFIRM)
  // 是否已经举报过了
  const getCanComplain = useImperativeQuery<
    canComplaint,
    canComplaintVariables
  >(COMPLAIN_CAN_COMPLAINT)
  const [canComplainLoading, setCanComplainLoading] = useState<boolean>(false)

  useEffect(() => {
    if (!visible) {
      setSelected(null)
      setRemark('')
      return
    }
    // 获取举报类型
    getComplainTypeList()
      .then(res => {
        const complaintTypeList =
          res?.data?.squareModule?.complaintTypeList || []
        setComplainTypeList(complaintTypeList)
      })
      .catch(e => {
        console.log('complain', e)
      })
  }, [visible])

  // 获取是否可以举报
  const onComplain = async () => {
    if (!validateIsLogin()) {
      return
    }
    if (!postId || canComplainLoading) {
      return
    }
    setCanComplainLoading(true)
    let canComplaint = false
    let content = '举报受理中,请耐心等待～'
    try {
      const res = await getCanComplain({
        postId,
      })
      canComplaint = res?.data?.squareModule?.canComplaint || false
    } catch (e) {
      content = graphQLErrorMessage(e) || content
      canComplaint = false
    }
    setCanComplainLoading(false)
    if (canComplaint) {
      setVisible(true)
    } else {
      message.destroy()
      message.error(content)
    }
  }

  // 确认举报
  const onComplainOk = async () => {
    if (!postId) {
      return
    }
    if (uploading) {
      return
    }
    message.destroy()
    if (!selected && selected !== 0) {
      message.error('请选择举报类型')
      return
    }

    try {
      const res = await sendComplain({
        variables: {
          param: {
            postId,
            reason: remark,
            typeIndex: selected,
            complaintReasonTemplate: 0,
          },
        },
      })
      if (res?.data?.squareModule?.succeed) {
        message.success('提交成功，请耐心等待～')
        setVisible(false)
      } else {
        message.error('提交失败，请稍后再试～')
      }
    } catch (e) {
      message.error('提交失败，请稍后再试～')
      console.log('err:', e)
    }
  }

  return (
    <>
      <span
        onClick={onComplain}
        className="cursor-pointer hover:text-primary transition-colors"
      >
        举报
      </span>
      <CustomMyModal
        dark
        open={visible}
        title="请选择举报类型"
        onCancel={() => setVisible(false)}
        maskStyle={{
          backgroundColor: 'rgba(0,0,0,0.8)',
        }}
        width={448}
        footer={null}
        transitionName=""
        maskTransitionName=""
        centered
      >
        {!!complainTypeList.length && (
          <Row gutter={4}>
            {complainTypeList.map((item, key) => (
              <Col key={key} span={8}>
                <div
                  className={classNames(styles.tag, {
                    [styles.tagActive]: selected === key,
                  })}
                  onClick={() => {
                    setSelected(key)
                  }}
                >
                  {item}
                </div>
              </Col>
            ))}
          </Row>
        )}
        <div className="text-xs text-neutral-400 my-3">具体原因</div>
        <div className={styles.inputArea}>
          <Input.TextArea
            maxLength={500}
            autoSize={{ minRows: 3 }}
            showCount
            placeholder="请补充举报理由（选填）"
            value={remark}
            onChange={e => setRemark(e.target.value)}
          ></Input.TextArea>
        </div>
        <div className="flex justify-between mt-3">
          <MyBtn
            type="default"
            $dark
            block
            size="large"
            className="!bg-neutral-200 !border-neutral-200"
          >
            取消
          </MyBtn>
          <MyBtn
            $dark
            type="primary"
            block
            size="large"
            className="ml-4"
            onClick={onComplainOk}
          >
            确认举报
          </MyBtn>
        </div>
      </CustomMyModal>
    </>
  )
}
